import { FC, useMemo, useRef, useState } from "react";
import { Outlet } from "react-router-dom";

import { RidesDragContextWrapper } from "@ryde/controls";
import { LayoutMainContext, useRtl, useSimpleNavigation } from "@ryde/redux";
import { useIsMobile } from "@ryde/shared";

import { UserActionsHistoryRecorder } from "../drawers/components/user-actions-history/parts";
import { LeftBar } from "../left/left-bar";
import { MobileHeader } from "../mobile";
import { MainStyled, PageLayoutGridStyled } from "./layout.styled";

export const LayoutMain: FC = () => {
  const { isEditRoute } = useSimpleNavigation();
  const mainRef = useRef<HTMLElement>(null);
  const { isMobile } = useIsMobile();
  const { direction } = useRtl();
  const [headerElement, setHeaderElement] = useState<HTMLElement | null>(null);

  const layoutMainContextValue = useMemo(
    () => ({
      mainElement: mainRef.current,
      headerElement,
      setHeaderElement,
    }),
    [headerElement],
  );

  return (
    <PageLayoutGridStyled dir={direction}>
      <RidesDragContextWrapper>
        {!isMobile && <LeftBar />}
        {isMobile && <MobileHeader />}
        <MainStyled $noScrollMode={isEditRoute} ref={mainRef}>
          <LayoutMainContext.Provider value={layoutMainContextValue}>
            <UserActionsHistoryRecorder />
            <Outlet />
          </LayoutMainContext.Provider>
        </MainStyled>
      </RidesDragContextWrapper>
    </PageLayoutGridStyled>
  );
};
